/**
 * EMP-MASTER-001 — Employee Master Database field configuration.
 * Single source for the form sections, view sections and empty-state builders.
 */

export const MASTER_SECTIONS = [
  {
    title: 'Employment Details',
    fields: [
      { key: 'designation', label: 'Designation' },
      { key: 'employment_type', label: 'Employment Type', type: 'select', options: ['Permanent', 'Probationary', 'Contract', 'Intern'] },
      { key: 'location', label: 'Location' },
      { key: 'grade_level', label: 'Grade / Level' },
    ],
  },
  {
    title: 'Personal Information',
    fields: [
      { key: 'nationality', label: 'Nationality' },
      { key: 'gender', label: 'Gender', type: 'select', options: ['Male', 'Female', 'Other'] },
      { key: 'date_of_birth', label: 'Date of Birth', type: 'date' },
      { key: 'marital_status', label: 'Marital Status', type: 'select', options: ['Single', 'Married', 'Widowed', 'Divorced'] },
      { key: 'blood_group', label: 'Blood Group' },
      { key: 'personal_email', label: 'Personal Email' },
    ],
  },
  {
    title: 'Contact & Address',
    fields: [
      { key: 'personal_contact_number', label: 'Personal Contact Number' },
      { key: 'official_contact_number', label: 'Official Contact Number' },
      { key: 'emergency_contact_name', label: 'Emergency Contact Name' },
      { key: 'emergency_contact_number', label: 'Emergency Contact Number' },
      { key: 'emergency_contact_relationship', label: 'Emergency Contact Relationship' },
      { key: 'permanent_address', label: 'Permanent Address', type: 'textarea', full: true },
      { key: 'present_address', label: 'Present Address', type: 'textarea', full: true },
    ],
  },
  {
    title: 'Statutory IDs',
    sensitive: true,
    fields: [
      { key: 'pan_number', label: 'PAN Card Number', sensitive: true },
      { key: 'aadhaar_number', label: 'Aadhaar Card Number', sensitive: true },
      { key: 'uan', label: 'UAN', sensitive: true },
      { key: 'member_id', label: 'Member ID', sensitive: true },
      { key: 'esi_number', label: 'ESI', sensitive: true },
      { key: 'ghi_member_id', label: 'Group Health Insurance Member ID', sensitive: true },
    ],
  },
  {
    title: 'Bank Details',
    fields: [
      { key: 'bank_name', label: 'Bank Name' },
      { key: 'bank_account_number', label: 'Bank Account Number', sensitive: true },
      { key: 'ifsc_code', label: 'IFSC Code' },
    ],
  },
];

export const buildEmptyMaster = () =>
  Object.fromEntries(MASTER_SECTIONS.flatMap(s => s.fields.map(f => [f.key, ''])));

export const pickMaster = (emp) =>
  Object.fromEntries(MASTER_SECTIONS.flatMap(s => s.fields.map(f => [f.key, emp?.[f.key] || ''])));
